<template>
  <footer class="app-footer">
    <div class="app-footer-cnt">
      <div class="footer-nav">
        <div class="nav-block">
          <img
            class="logo"
            :src="require('../assets/onlysales-logo-white.svg')"
            alt="Onlysales"
            width="152px"
            height="32px"
          />

          <div class="supporting-text">
            <p>
              Onlysales est l'agence de performance commerciale qui vous épaule
              pour recruter, former puis coacher les meilleurs commerciaux.
            </p>
            <p>
              Chasse de tête de commerciaux, accompagnement au process de
              recrutement, onboarding et formation de votre équipe sales :
              Onlysales est le partenaire clé pour le succès de votre stratégie
              commerciale.
            </p>
          </div>
        </div>

        <div class="nav-block">
          <div class="body-lg fsemibold">Candidats</div>
          <a href="https://onlysales.fr/post-resume" target="_blank"
            >Publier un profil</a
          >
          <a href="https://onlysales.fr/jobs" target="_blank"
            >Consulter les offres</a
          >

          <div class="body-lg fsemibold header-2">Recruteurs</div>
          <a href="https://onlysales.fr/poster-un-emploi" target="_blank"
            >Publier une offre</a
          >
          <a href="https://onlysales.fr/candidates/" target="_blank"
            >Consulter les profils</a
          >
        </div>

        <div class="nav-block solutions" style="display: none">
          <div class="body-lg fsemibold">Solutions</div>
          <a href="https://onlysales.fr" target="_blank">Recrutement</a>
          <a href="https://onlysalesacademy.fr" target="_blank">Formation</a>
          <a href="https://onlysalesacademy.fr" target="_blank">Coaching</a>
          <a href="https://onlysalesacademy.fr" target="_blank">Strategie</a>
        </div>

        <div class="nav-block">
          <div class="contacts">
            <div class="body-lg fsemibold">Discutons !</div>
            <div class="contact-item">
              <img
                :src="require('../assets/mail.svg')"
                alt="mail"
                width="16px"
                height="16px"
              />
              <a href="mailto:hello@onlysales.fr">hello@onlysales.fr</a>
            </div>
            <div class="contact-item">
              <img
                :src="require('../assets/phone.svg')"
                alt="phone"
                width="16px"
                height="16px"
              />
              <a href="tel:+33756956912">07 56 95 69 12</a>
            </div>
            <div class="contact-item">
              <img
                :src="require('../assets/map-pin.svg')"
                alt="location"
                width="16px"
                height="16px"
              />
              <span>2 blv. Beaumarchais, 75011 Paris</span>
            </div>

            <div class="social-cnt">
              <a :href="social.facebook" target="_blank">
                <img
                  :src="require('../assets/fb-icon.svg')"
                  alt="facebook"
                  width="24px"
                  height="24px"
                />
              </a>
              <a :href="social.linkedin" target="_blank">
                <img
                  :src="require('../assets/lkn-icon.svg')"
                  alt="linkedin"
                  width="24px"
                  height="24px"
                />
              </a>
            </div>
          </div>
        </div>
      </div>

      <div class="products">
        <div class="products-cnt">
          <div class="product-wording">Découvrez nos produits: </div>
          <div class="product-item">
            <img
              :src="require('../assets/os-jobs.svg')"
              alt="Onlysales Jobs"
              width="24px"
              height="24px"/>
            <a href="https://onlysales.fr" target="_blank">Jobs</a>
          </div>
          <div class="product-item">
            <img
              :src="require('../assets/os-academy.svg')"
              alt="Onlysales Academy"
              width="24px"
              height="24px"/>
            <a href="https://onlysalesacademy.fr" target="_blank">Academy</a>
          </div>
          <div class="product-item">
            <img
              :src="require('../assets/os-profiles.svg')"
              alt="Onlysales Profiles"
              width="24px"
              height="24px"/>
            <a href="https://profiles.onlysales.fr" target="_blank">Profiles</a>
          </div>
          <div class="product-item">
            <img
              :src="require('../assets/os-trackers.svg')"
              alt="Onlysales Trackers"
              width="24px"
              height="24px"/>
            <a href="https://tracker.onlysales.fr" target="_blank">Tracker</a>
          </div>
        </div>
      </div>

      <div class="cgu">
        <span>Onlysales.fr</span>
        - Made with <span class="heart" :class="{ ot }">♥</span> in Paris -
        <router-link to="/terms"
          >Conditions Générales d'Utilisation</router-link
        >
      </div>
    </div>
  </footer>
</template>

<script>
import { social } from "../vars";

export default {
  name: "AppFooter",
  props: {
    ot: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    return {
      social,
    };
  },
};
</script>

<style lang="scss">
.app-footer {
  background-color: $neutral900;
  color: $neutral200;
  height: 628px;
  padding-top: 64px;

  .app-footer-cnt {
    width: $desktopContainer;
    margin: 0 auto;

    .footer-nav {
      display: flex;
      justify-content: space-between;
      
      .nav-block {
        display: inline-block;
        margin-left: 42px;
        padding-top: 4px;
        vertical-align: top;

        .supporting-text {
          font-size: 14px;
        }

        .body-lg {
          margin-bottom: 18px;

          &.header-2 {
            margin-top: 32px;
          }
        }

        a {
          display: block;
          margin-bottom: 12px;

          font-family: "Inter";
          font-style: normal;
          font-weight: 400;
          font-size: 16px;
          line-height: 24px;
          color: $neutral200;
          text-decoration: none;
        }

        .logo {
          margin-bottom: 16px;
        }

        &:first-child {
          width: 320px;
          margin-left: 0;
          padding-top: 0;
        }

        .contacts {
          border: 1px solid $neutral700;
          border-radius: 16px;
          padding: 32px;
          min-width: 333px;

          .contact-item {
            img {
              float: left;
              margin-right: 8px;
              margin-top: 4px;
            }
          }

          .social-cnt {
            margin-top: 32px;

            a {
              display: inline-block;
              margin-right: 16px;
            }
          }
        }
      }
    }

    .products {
      margin: 64px 0;
      border: 1px solid $neutral700;
      border-radius: 16px;
      padding: 24px 32px 24px 32px;

      .products-cnt {
        display: flex;
        justify-content: center;
        align-items: center;

        .product-item {
          display: flex;
          align-items: center;
          margin-left: 24px;

          img {
            margin-right: 8px;
          }

          a {
            text-decoration: none;
            color: $neutral200;
            font-weight: 400;
          }
        }
      }
    }

    .cgu {
      text-align: center;
      font-family: "Inter";
      font-style: normal;
      font-weight: 400;
      font-size: 16px;
      line-height: 24px;
      color: $neutral500;

      .heart {
        color: $primary300;

        &.ot {
          color: $primaryOt300;
        }
      }

      a {
        color: $neutral500;
      }
    }
  }
}

@media screen and (max-width: $mobileBreakpoint) {
  .app-footer {
    height: auto;
    padding-bottom: 48px;

    .app-footer-cnt {
      width: $mobileContainer;

      .footer-nav {
        display: block;
        .nav-block {
          display: block;
          margin: 32px 0;

          &:nth-child(2) {
            margin-top: 64px;
          }

          &:last-child {
            margin-bottom: 64px;
          }
        }
      }

      .products {
        margin: 32px 0;

        .products-cnt {
          display: block;
          
          .product-wording {
            font-size: 18px;
            font-weight: 600;
            margin-bottom: 32px;
          }

          .product-item {
            margin-left: 0;
            margin-bottom: 16px;
          }
        }
      }

      .cgu {
        text-align: left;
      }
    }
  }
}
</style>